import React from "react";

import "./style.scss";

const Error = () => {
  return (
    <div className="margin-top">
      <h2>Page non trouvée.</h2>
    </div>
  );
};

export default Error;
